<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'moi.eventSummary.cardTitle' | transloco }}</div>
    @if (summaryModel) {
        <div class="detail-page-card-actions">
            @if (summaryModel.CanOpenParent) {
                <button class="btn btn-raised" (click)="openEvent()">
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'moi.eventSummary.openEventBtn' | transloco }}</span>
                </button>
            }
        </div>
    }

    <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
        @if (summaryModel) {
            <div class="row">
                <div class="col-12 col-xl-6 left-block">
                    <div class="row">
                        <div class="col-3">
                            <div class="form-group">
                                <label>{{ 'moi.eventSummary.identifierLabel' | transloco }}</label>
                                <input
                                    data-uiid="event-moi-identifier"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.Identifier"
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-9">
                            <div class="form-group">
                                <label>{{ 'moi.eventSummary.eventNameLabel' | transloco }}</label>
                                <input
                                    data-uiid="event-moi-name"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.Name"
                                    inputTooltip
                                />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.eventSummary.dateOccurredLabel' | transloco }}</label>
                                <date-input
                                    data-uiid="event-moi-dateoccurred"
                                    [(value)]="summaryModel.DateOccurred"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.eventSummary.dateDetectedLabel' | transloco }}</label>
                                <date-input
                                    data-uiid="event-moi-datedetected"
                                    [(value)]="summaryModel.DateDetected"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-xl-6 right-block">
                    <div class="form-group">
                        <label>{{ 'moi.eventSummary.descriptionLabel' | transloco }}</label>
                        <textarea
                            data-uiid="event-moi-description"
                            class="form-control form-control-sm"
                            disabled
                            [rows]="5"
                            [value]="summaryModel.Description"
                            inputTooltip
                        ></textarea>
                    </div>
                </div>
            </div>
        } @else {
            <div class="fancy-loader submodule my-4"></div>
        }
    </div>
</div>
